//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        activePlanetName: {
            type: String,
            default: ''
        }
    },

    data () {
        return {
            showGameFinishedPlanetPopup: false,
            activePlanet: {},
            animationFunction: null
        };
    },

    computed: {
        planets () {
            let activePlanetIndex = this.$store.getters.planets.findIndex(planet => planet.name[this.$lang.locale] === this.activePlanetName);
            let planets = this.$store.getters.planets.map(planet => ({
                ...planet,
                finished: this.$store.getters.hasUserFinishedWeek(planet.week)
            }));

            if (activePlanetIndex !== -1) {
                return [
                    ...planets.slice(activePlanetIndex),
                    ...planets.slice(0, activePlanetIndex)
                ];
            }

            return planets;
        }
    },

    methods: {
        goToPlanet (planet) {
            this.activePlanet = planet;

            let weekRoute = this.$store.getters.getWeekRoute(planet.week);

            if (planet.finished && weekRoute === null) {
                this.showGameFinishedPlanetPopup = true;
                return;
            }

            if (this.$store.getters.playThrough) {
                this.$router.push({
                    name: weekRoute !== null ? weekRoute : planet.route
                });
            }
        }
    }
};
